import {useMapContext} from '@/components/MindMap/index.mjs'
import useMenuItemAddBranchToIsrf from '../../../menuItems/useMenuItemAddBranchToIsrf.jsx'
import useMenuItemCreateBranchFromIsrf from '../../../menuItems/useMenuItemCreateBranchFromIsrf.jsx'
import useMenuItemRemoveBranchFromIsrf from '../../../menuItems/useMenuItemRemoveBranchFromIsrf.jsx'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonBranch(props) {
    const map = useMapContext()

    const items = [
        useMenuItemCreateBranchFromIsrf(),
        useMenuItemAddBranchToIsrf(),
        useMenuItemRemoveBranchFromIsrf(),
    ]

    if (map.root.data.prjMapFlag) {
        return null
    }

    return (
        <MenuButton
            items={items}
            {...props}
        >
            增量分支
        </MenuButton>
    )
}
